export default "__VITE_ASSET__5w5jc_Wk__"